import React from 'react'
import { Navigate, Outlet} from 'react-router-dom'
import { useUser } from '../context/user'
import { CircularProgress } from '@mui/material'
const PrivateRoute = () => {
    const user = useUser();

    // Show loading spinner while authentication is being checked
    if (user.loading) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                fontSize: '18px'
            }}>
                <CircularProgress/>
            </div>
        );
    }

    // Once loading is complete, check if user is authenticated
    return user.current ? <Outlet /> : <Navigate to="/auth" />;
}

export default PrivateRoute